import { ProposedToTheSubCommittee4ApproveViewComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/ProposedToTheSubCommittee4ApproveViewComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function PoposedToTheSubCommittee4ApproveContainer() {
    const titleName = "มติที่ประชุม แบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
    const subtitle = "(สำหรับผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงานและผู้ประกอบกิจการ)"
    return (
        <div className="page-container bg-landing">
            <NavbarBorrowSystem />
            <HeadTitle title={titleName} subtitle={subtitle} />
            <ProposedToTheSubCommittee4ApproveViewComponent />
            <Footer />
        </div>

    )
}




